export default "__VITE_ASSET__C1e78F4F__"